import script from "./Person.vue?vue&type=script&setup=true&lang=ts"
export * from "./Person.vue?vue&type=script&setup=true&lang=ts"

import "./Person.vue?vue&type=style&index=0&id=64e366cf&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e366cf"]])

export default __exports__